/** @format */

import React, { FunctionComponent } from 'react';
import MvnoBlockApiRequest from '../../../interfaces/platform/MvnoBlockApiRequest';
import GridItem from '../../../components/Grid/GridItem';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Card/CardHeader';
import { Typography } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import GridContainer from '../../../components/Grid/GridContainer';
import CardBody from '../../../components/Card/CardBody';

export type ApiRestViewDetailType = {
    classes: any;
    item: MvnoBlockApiRequest;
};

export const ApiRestViewDetail: FunctionComponent<ApiRestViewDetailType> = ({ classes, item }) => {
    const variant = 'subtitle2';

    const convertJsoin = (json: string | null): string => {
        let convertedJson = '';
        if (json) {
            convertedJson = JSON.stringify(JSON.parse(json), null, 2);
        }
        return convertedJson;
    };
    2;

    return (
        <GridContainer>
            <GridItem xs={12}>
                {item.apiIri && (
                    <>
                        <h4>
                            {item.method} : {item.apiIri}
                        </h4>
                    </>
                )}
                <Card>
                    <CardHeader>
                        <Typography variant={variant}>
                            <I18n trans="prov:api.api_rest_request" />
                        </Typography>
                    </CardHeader>
                    <CardBody>
                        <pre>{item.apiRequestQuery && convertJsoin(item.apiRequestQuery)}</pre>
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12}>
                <Card>
                    <CardHeader>
                        <Typography variant={variant}>
                            <I18n trans="prov:api.api_rest_response" />
                        </Typography>
                    </CardHeader>
                    <CardBody>
                        <pre>{item.apiResponseQuery && convertJsoin(item.apiResponseQuery)}</pre>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    );
};
